import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './app/ui/main/App';
import { init, noticeError } from 'app/api/analytics/reporting';

try {
  init();
  ReactDOM.render(<App />, document.getElementById('root'));
} catch (e) {
  noticeError(e);
  document.getElementById('root').innerHTML =
    'Oops! Something went wrong. Please try again later!';
  document.getElementById('staticloader').remove();
}
